import { PayPerLeadSubscription } from "@containers/PayPerLead/interface";
import { MIN_REMAINING_BALANCE } from "@containers/PayPerLead/store/constants";
import { Discount } from "@shared/models";

export const isPaymentRequired = (subscription: PayPerLeadSubscription): boolean => {
  return !!(
    subscription.end_date &&
    subscription.is_active &&
    (subscription?.remaining_balance || 0) < MIN_REMAINING_BALANCE &&
    subscription?.renew &&
    subscription.lock
  );
};

export const getUnpaidSubscriptions = (subscriptions: PayPerLeadSubscription[]) => {
  return subscriptions.filter(isPaymentRequired);
};

export const applyDiscounts = (price: number, discounts?: Discount[], inCents?: boolean) =>
  (discounts || []).reduce((sum, discount) => {
    if (discount.percent_off) return (sum * (100 - discount.percent_off)) / 100;

    if (discount.amount_off) return sum - discount.amount_off / (inCents ? 1 : 100);

    return sum;
  }, price);
